import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Categorie} from '../../dienst/categorie';
import {Taak, TaakType} from '../../dienst/taak';
import {Prestatie} from '../../prestatie/prestatie';
import {Diensten} from '../../dienst/diensten';
import {Dienst} from '../../dienst/dienst';
import {TakenListComponent} from './taken-list/taken-list.component';
import {TaakTipAantal} from '../../tip/taak-tip-aantal';
import User from '../../core/auth/user';
import {Client} from '../client';
import {Zone} from '../../zone/zone';
import {ClientDienst} from "../client-dienst";

@Component({
    selector: 'zah-client-diensten',
    templateUrl: './client-diensten.component.html',
    styleUrls: ['./client-diensten.component.scss'],
    standalone: false
})
export class ClientDienstenComponent {

  @Input()
  user: User;
  @Input()
  client: Client;
  @Input()
  prestatie: Prestatie;
  @Input()
  diensten: Diensten;
  @Input()
  zones: Array<Zone>;
  @Input()
  taakTipAantallen: Array<TaakTipAantal>;
  @Input()
  emptyLabel: string;
  @Output()
  meldingenClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  prestatieClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  signaalkaartClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  wijzigClientClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  clientFicheClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  tipsOpened: EventEmitter<[string, string, string]> = new EventEmitter<[string, string, string]>();

  @ViewChild(TakenListComponent)
  private takenListComponent: TakenListComponent;

  dienst: Dienst;
  categorie: Categorie;
  taken: Array<Taak>;

  onMeldingenClicked(): void {
    this.meldingenClicked.emit();
  }

  onPrestatieClicked(): void {
    this.prestatieClicked.emit();
  }

  onSignaalkaartClicked(): void {
    this.signaalkaartClicked.emit();
  }

  onWijzigClientClicked(): void {
    this.wijzigClientClicked.emit();
  }

  onClientFicheClicked(): void {
    this.clientFicheClicked.emit();
  }

  openCategory([dienst, taakType, categorie]: [Dienst, TaakType, Categorie]): void {
    this.dienst = dienst;
    this.categorie = categorie;
    this.taken = categorie.getTakenByType(taakType);
    this.takenListComponent?.scrollTop();
  }

  onTipsOpened([dienstId, categorieId, taakId]: [string, string, string]): void {
    this.tipsOpened.emit([dienstId, categorieId, taakId]);
  }
}
